module.exports = __webpack_public_path__ + "img/payu_long.cb294715.svg";